<template>
    <div class="g-timer">
        <dl class="g-timer-left">
            <dt class="g-timer-price">
                <span class="yuan">Ks</span>
                <span class="integer">{{groupPriceText.integer}}</span>
                <span class="pointer">.</span>
                <span class="decimal">{{groupPriceText.decimal}}</span>
            </dt>
            <dd class="g-timer-sign">
                <div class="sign"><i></i><span class="sign-title"><em>{{groupRequireNum}}</em>人拼团</span></div>
                <div class="old-price">Ks{{normalPrice}}</div>
            </dd>
            <dd class="g-timer-content">
                <p class="province">拼团省<em>{{provinceText}}</em>Ks</p>
                <p class="piece">已团<em>{{groupsSaleNum}}</em>件</p>
		    </dd>
        </dl>
        <dl class="g-timer-right g-end" v-if="groupEnd">
            <dt class="timer-text">活动已结束</dt>
        </dl>
        <dl v-else class="g-timer-right ">
            <dt class="timer-text">距活动结束</dt>
            <dd class="timer-upside" ref="timeDown"></dd>
        </dl>
    </div>
</template>
<script>
    var endTimeUnix = 0;
    export default {
        props: ['groupPrice', 'normalPrice','groupsSaleNum', 'groupRequireNum', 'endTime' , 'groupState'],

        data:function(){
            return {
                //活动结束
                isEnd : false
            }
        },
        computed: {
            //团购结束
            groupEnd : function(){
                return  this.groupState == 0
            },
            groupPriceText() {
                var _price =this.$convertPrice(this.groupPrice).split(".")
                return {
                    integer: _price[0],
                    decimal: _price[1]
                }
            },
            // 拼团剩多少钱
            provinceText(){
                var  sub = this.$number.sub
                return sub(this.normalPrice ,  this.groupPrice)
            }
        },

        mounted() {

            this.refreshTimePlugin()
        },
        updated() {

            this.refreshTimePlugin()
        },
        methods: {

            replaceLetter: function (value) {
                return value.replace(/-+/g, "/")
            } , 
            //刷新倒计时
            refreshTimePlugin() {
                if (endTimeUnix) return
                endTimeUnix = (this.endTime) / 1000
                if (endTimeUnix < 0 ){
                    return ;
                }else{
                    $(this.$refs.timeDown).ncCountDown({
                        time: endTimeUnix,
                        cndays:"timer-day",
                        cnminutes:"timer-hours",
                        cnallHours:'timer-hours',
                        cnhours:'timer-hours',
                        cnseconds:'timer-hours',
                        unitDay: "<i>天</i>",
                        unitHour: "<em>:</em>",
                        unitMinute: "<em>:</em>",
                        unitSecond: "",
                        warp: "span",
                        hideDay: false,
                        end: function() {

                        }
                    });
                }


            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/group-countdown/group-countdown.vue